module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_02-d3f1bf42abc17c91f02032e54b0f97c5.png";